import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  input,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubSectorPipe } from '@app/features-modules/bolsa-de-profissionais/pipes/sub-sector.pipe';
import { Button } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { Avatar } from 'primeng/avatar';
import { AvatarGroup } from 'primeng/avatargroup';
import { TooltipModule } from 'primeng/tooltip';
import { EmpresaSectorService } from '@app/features-modules/bolsa-de-profissionais/services/empresa-sector.service';
import { ProfissionalService } from '@app/features-modules/bolsa-de-profissionais/services/profissional.service';
import { ApiService } from '@core/providers/http';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-mais-detalhe-empresa',
  imports: [
    CommonModule,
    TagModule,
    SubSectorPipe,
    Button,
    Avatar,
    AvatarGroup,
    TooltipModule,
  ],
  providers: [ApiService, EmpresaSectorService, ProfissionalService],
  templateUrl: './mais-detalhe-empresa.component.html',
  styleUrl: './mais-detalhe-empresa.component.scss',
  standalone: true,
})
export class MaisDetalheEmpresaComponent implements OnInit {
  @Input() avatar!: string;

  empresaSelected = input<any>();
  route: ActivatedRoute = inject(ActivatedRoute);
  @Output() onCloseModal = new EventEmitter<boolean>();

  private empresaService = inject(EmpresaSectorService);
  private profissionalService = inject(ProfissionalService);

  getInitials = getInitials;
  empresaImageError = false;
  profissionaisCount = 0;
  companyProfissionais: Array<{
    id: number;
    nome: string;
    photoUrl?: string | null;
    imageError?: boolean;
  }> = [];

  imagePreview: string | ArrayBuffer | null = null; // To store image as Base64 URL

  showDetalhe: boolean = false;
  isLoading: boolean = false;
  perfilEmpresa: any;
  empresaId!: string;

  ngOnInit(): void {
    this.empresaId = this.route.snapshot.paramMap.get('id')!;
    this.loadEmpresaDetails(this.empresaId);
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.getPhoto(id);
    }
  }

  getPhoto(id: number) {
    this.empresaService.getPhotoEmpresaIdGet(id).subscribe((response) => {
      if (response) {
        if (!response || !response.type.startsWith('image/')) {
          console.warn('Resposta não é imagem. A usar placeholder.');
          this.imagePreview = null;
          return;
        }
        const reader = new FileReader();
        reader.onload = () => {
          this.imagePreview = reader.result; // <- exibe a imagem convertida em base64
        };
        reader.readAsDataURL(response); // <- importante: precisa ser um Blob aqui
      }
    });
  }

  loadEmpresaDetails(empresaId: string) {
    this.empresaImageError = false;
    this.empresaService.show(empresaId).subscribe((result) => {
      this.perfilEmpresa = result;
      this.loadProfissionaisEmpresa(this.perfilEmpresa?.id || empresaId);
    });
  }

  loadProfissionaisEmpresa(empresaId: number | string) {
    this.profissionalService
      .list({ EmpresaID: empresaId, pageNumber: 1, pageSize: 4 })
      .subscribe({
        next: (result: any) => {
          this.profissionaisCount = result?.totalRecords || 0;
          const list = result?.data || [];
          this.companyProfissionais = list.slice(0, 4).map((prof: any) => ({
            id: prof.id,
            nome: prof.nome,
            photoUrl: null,
            imageError: false,
          }));

          this.companyProfissionais.forEach((prof) => {
            this.profissionalService.getPhoto(String(prof.id)).subscribe({
              next: (res: any) => {
                if (res && res.type?.startsWith('image/')) {
                  const reader = new FileReader();
                  reader.onload = () => {
                    prof.photoUrl = reader.result as string;
                  };
                  reader.readAsDataURL(res);
                }
              },
              error: () => {
                prof.photoUrl = null;
              },
            });
          });
        },
        error: (err: any) => {
          console.warn('Erro ao carregar profissionais em mais-detalhes:', err);
        },
      });
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }
  estadoVagaMap: Record<number, { label: string; severity: any }> = {
    1: { label: 'Activa', severity: 'success' },
    2: { label: 'Inactiva', severity: 'danger' },
  };
}
